import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import { customerAuthAPI } from '../../services/api';
import { User, Phone, Save } from 'lucide-react';

export default function CompleteProfile() {
    const { customer, updateCustomer } = useCustomerAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        firstName: customer?.firstName || '',
        lastName: customer?.lastName || '',
        phone: customer?.phone || ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (!customer) {
        navigate('/giris');
        return null;
    }

    // Already complete
    if (customer.phone) {
        navigate('/hesabim');
        return null;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!form.firstName.trim() || !form.lastName.trim()) {
            return setError('Ad ve soyad zorunludur');
        }
        if (!form.phone.trim()) {
            return setError('Telefon numarası zorunludur');
        }
        if (form.phone.replace(/\D/g, '').length < 10) {
            return setError('Geçerli bir telefon numarası girin');
        }

        setLoading(true);
        try {
            const res = await customerAuthAPI.updateProfile(form);
            updateCustomer(res.data.customer);
            navigate('/hesabim', { replace: true });
        } catch (err) {
            setError(err.response?.data?.error || 'Bir hata oluştu');
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-container complete-profile-container">
                <div className="auth-header">
                    <User size={32} />
                    <h1>Profilini Tamamla</h1>
                    <p>Devam etmek için bilgilerini doldur</p>
                </div>

                {error && <div className="auth-error">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="auth-field">
                        <User size={18} />
                        <input
                            type="text"
                            placeholder="Adınız"
                            value={form.firstName}
                            onChange={e => setForm({...form, firstName: e.target.value})}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <User size={18} />
                        <input
                            type="text"
                            placeholder="Soyadınız"
                            value={form.lastName}
                            onChange={e => setForm({...form, lastName: e.target.value})}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <Phone size={18} />
                        <input
                            type="tel"
                            placeholder="Telefon numaranız (05XX XXX XX XX)"
                            value={form.phone}
                            onChange={e => setForm({...form, phone: e.target.value})}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                        <Save size={18} />
                        {loading ? 'Kaydediliyor...' : 'Kaydet ve Devam Et'}
                    </button>
                </form>
            </div>
        </div>
    );
}
